import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useDispatch } from "react-redux";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PullToRefresh from "react-simple-pull-to-refresh";
import helpIcon from "../../assets/images/icon_card/help.svg";
import Config from "../../config/Config";
import { useAppSelector } from "../../core/feature/hooks";
import CustomApp from "../../core/models/customApp";
import User from "../../core/models/user";
import TabsMobile from "../__template/TabsMobileComponent";
import logoCompany from "../../assets/images/logo-company.svg";
import { statusBookingById } from "../../core/service/api_pickup_student";
import Countdown, { zeroPad } from "react-countdown";
import { setLanguage } from "../../core/feature/language/languageSlice";
import moment from "moment";
import { addSeparatorText } from "../../config/global";
const PickupStudentMobile = (props: any) => {
  const user: User = useAppSelector((state) => state.user.user);
  const [company, setCompany] = useState<any>({});
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const language: String = useAppSelector((state) => state.language.language);
  const token: String = useAppSelector((state) => state.token.token);
  const navigate = useNavigate();
  const query = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isScanOpen, setIsScanOpen] = useState(false);
  const [data, setData] = useState<any>({});
  const { t } = useTranslation();
  const [timer, setTimer] = useState(0);
  const [countSend, setCountSend] = useState(0);
  const [countdown, setCountdown] = useState(false);

  const env = Config.BaseUrlDev;

  useEffect(() => {
    // setCompany(JSON.parse(localStorage.getItem("company") || ""));
    // if (user == undefined) {
    //   navigate("/login", { replace: true });
    // } else {
    // }
    if (query.id) getDetail();
  }, []);

  useEffect(() => {
    if (location.pathname.split("/")[2] != undefined) {
    }
  }, [location.pathname.split("/")[2]]);

  function closeScanModal() {
    setIsScanOpen(false);
  }

  const handleRefresh = async () => {};
  const getDetail = async () => {
    let response = await statusBookingById(query.id);
    console.log(response);
    setData(response.data);
    setTimer(response.data.timestampCountdown);
    setCountdown(true);
  };
  const renderer = (
    // { hours, minutes, seconds, completed }
    data: any
  ) => {
    if (data.completed) {
      setCountdown(false);
      return (
        // <button
        //   className="text-psp-primary font-medium text-center text-sm font-montserrat"
        //   onClick={() => {
        //     setCountSend(0);
        //     setTimer(Date.now() + 300000);
        //   }}
        // >
        //   {t("LOGIN.send")}
        // </button>
        <span className="text-center font-bold">Selesai</span>
      );
    } else {
      setCountdown(true);
      // Render a countdown
      return (
        <span className="text-center font-bold">
          {data.days && `${zeroPad(data.days)} Hari `}
          {zeroPad(data.hours)}:{zeroPad(data.minutes)}:{zeroPad(data.seconds)}
        </span>
      );
    }
  };

  return (
    <>
      <div className="relative min-h-screen h-full  bg-psp-primary pb-10">
        {/* <div className="bg-white px-8 pt-8 pb-3  sticky top-0 z-50">
          <TabsMobile
            name={`${t("PICKUPSTUDENT.title")}`}
            backUrl={"home"}
          ></TabsMobile>
        </div> */}
        <PullToRefresh className="text-center" onRefresh={handleRefresh}>
          <div className="text-left h-full  px-4 py-6 bg-psp-primary top-to-bottom font-montserrat">
            <section className="mt-5 w-full h-full">
              <div className="flex flex-col justify-start h-full w-full">
                <div className="flex flex-col gap-3 justify-center w-full">
                  <div
                    // onClick={() => props.toDetailPage(el.pickupId)}
                    className="scooped-radial-bottom w-full flex flex-col gap-4 justify-center px-10 py-10 items-center bg-white  cursor-pointer"
                  >
                    <div className="flex flex-col gap-3">
                      <span className="text-center font-medium">
                        Kode Booking anda adalah
                      </span>
                      <span className="text-center text-6xl font-bold text-blue-500">
                        {/* {addSeparatorText(data.pickupCode, 4)} */}
                        {addSeparatorText(data.pickupCode?.substr(0, 6), 3)}
                      </span>
                    </div>
                    <span className="dotted-spaced w-full h-1"></span>
                    <div className="flex flex-col gap-3">
                      <span className="text-center font-medium">Nama Anak</span>
                      <span className="text-center font-bold">{data.name}</span>
                    </div>
                    <div className="flex flex-col gap-3">
                      <span className="text-center font-medium">
                        Range Tanggal
                      </span>
                      <span className="text-center font-bold">
                        {language == "en"
                          ? t(
                              moment(data.startDate)
                                .lang("en")
                                .format("DD MMMM YYYY")
                            )
                          : t(
                              moment(data.startDate)
                                .lang("id")
                                .format("DD MMMM YYYY")
                            )}
                        {/* {data.startDate} */}
                      </span>
                      <span className="text-center font-bold">
                        {language == "en"
                          ? t(
                              moment(data.endDate)
                                .lang("en")
                                .format("DD MMMM YYYY")
                            )
                          : t(
                              moment(data.endDate)
                                .lang("id")
                                .format("DD MMMM YYYY")
                            )}
                        {/* {data.endDate} */}
                      </span>
                    </div>
                    <div className="flex flex-col gap-3">
                      <span className="text-center font-medium">
                        Estimasi Waktu
                      </span>
                      {/* <span className="text-center font-bold">
                        {moment(timer).format("DD MMMM YYYY")}
                      </span> */}
                      <Countdown key={timer} date={timer} renderer={renderer} />
                    </div>
                    <span className="text-center font-medium">
                      Silahkan Masukan Kode Booking ke dalam Device Sekolah atau
                      Masukan Scan QR
                    </span>
                    <span className="dotted-spaced w-full h-1"></span>
                    <img src={logoCompany} alt="" />
                  </div>
                </div>
              </div>
            </section>
          </div>
        </PullToRefresh>
      </div>
      <Transition appear show={isScanOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeScanModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-psp-primary p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    <div className="flex flex-row">
                      <img src={helpIcon} alt="" className="text-black mr-2" />
                      {/* <div>{t("DIGITALCARD.help")}</div> */}
                    </div>
                  </Dialog.Title>
                  <div className="rounded-2xl bg-psp-primary mt-3 p-2"></div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default PickupStudentMobile;
